import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { homeApi } from '../api/homeApi';
import { userApi } from '../api/userApi';


const initialState: any = {
  userData: null,
  suggestedUser: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(userApi.endpoints.getUserByIdData.matchFulfilled, (state, { payload }: any) => {
        state.userData = payload.data;
      });
    builder
      .addMatcher(userApi.endpoints.suggestedUser.matchFulfilled, (state, { payload }: any) => {
        state.suggestedUser = payload?.data?.users;
      });
  },
});

export const {  } = userSlice.actions;

export default userSlice.reducer;
